<template>
  <header>
    <section>
      <div class="col1">
        <router-link to="/">
          <h3>Hey, I see a {{userProfile.name}}!</h3>
        </router-link>
        <ul class="inline">
          <!-- <li>
            <router-link to="logs">Logs</router-link>
          </li>
          <li>
            <router-link to="objectives">Objectives</router-link>
          </li>
          <li>
            <router-link to="quests">Quests</router-link>
          </li> -->
          <li>
            <router-link to="settings">Settings</router-link>
          </li>
          <li>
            <a @click="logout">Logout</a>
          </li>
        </ul>
      </div>
    </section>
  </header>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')
export default {
  computed: {
    ...mapState(['currentUser', 'userProfile'])
  },
  methods: {
    logout () {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch('clearData')
          this.$router.push('/login')
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="scss">
header {
  position: relative;
  background: $light1;
  /*box-shadow: 0 5px 5px -5px rgba($dark1, 0.5);*/
  z-index: 10;

  h3 {
    display: inline-block;
  }

  ul {
    @include inline;
    float: right;
    text-align: right;

    li {
      margin-top: 4px;
      margin-left: 6px;

      a {
        display: block;
        padding: 5px;
      }
    }
  }

  @media screen and (max-width: 742px) {
    h3 {
      display: block;
      text-align: center;
    }

    ul {
      float: none;
      text-align: center;
    }
  }
}

.col1,
.col2 {
  flex-grow: 1;
  flex-basis: 0;
  padding: 1rem;

  @media screen and (max-width: 742px) {
  }
}

a {
  font-family: "Open Sans", sans-serif;
  text-decoration: none;
  color: $primary;
  margin: 0;
  cursor: pointer;

  &:hover {
    color: lighten($primary, 5%);
  }
}
</style>
